import { IGroupNCI } from '../../types/types';

export const initialNetCarbonIntensitySate: IGroupNCI[] = [
  {
    EMISSIONS: 0,
    EMISSIONS_UNIT: '',
    GROUP_NCI_TARGET_HIGHER: 0,
    GROUP_NCI_TARGET_LOWER: 0,
    GROUP_NCI_TARGET_UNIT: '',
    GROUP_VOLUME: 0,
    GROUP_VOLUME_UNIT: '',
    NET_ABSOLUTE_EMISSIONS: 0,
    NET_ABSOLUTE_EMISSIONS_UNIT: '',
    OFFSETS: 0,
    OFFSETS_UNIT: '',
    OPERATING_PLAN: '',
    REPORTED_GROUP_NCI: 0,
    YEAR: 0,
    CHANGED_GROUP_VOLUME: 0,
    CHANGED_NET_ABSOLUTE_EMISSIONS: 0,
    CHANGED_REPORTED_GROUP_NCI: 0,
  },
];
